export enum SupportedLanguageCodes {
  English = 'en-US',
  French = 'fr-CA',
  EnglishCA = 'en-CA',
}
